import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElementModel } from '@app/clinical-feedback/clinical-feedback.model';

@Component({
    selector: 'app-contact-person',
    templateUrl: './contact-person.component.html',
    styleUrls: []
})
export class ContactPersonComponent {
    @Input() parentFormGroup!: UntypedFormGroup;
    @Input() formElementModel!: FormElementModel;
    @Input() disableLabel = false;

    get nameFormElementModel() {
        return new FormElementModel({
            id: `${this.formElementModel.id}Name`,
            fieldName: 'Name',
            label: this.disableLabel ? '' : 'Name'
        });
    }

    get emailFormElementModel() {
        return new FormElementModel({
            id: `${this.formElementModel.id}Email`,
            fieldName: 'Email',
            label: this.disableLabel ? '' : 'Email'
        });
    }

    get phoneFormElementModel() {
        return new FormElementModel({
            id: `${this.formElementModel.id}Phone`,
            fieldName: 'Phone',
            label: this.disableLabel ? '' : 'Phone'
        });
    }

    get phoneExtFormElementModel() {
        return new FormElementModel({
            id: `${this.formElementModel.id}PhoneExt`,
            fieldName: 'Extension',
            label: this.disableLabel ? '' : 'Extension'
        });
    }
}

export enum ContactPersonFieldType {
    Name,
    Email,
    Phone,
    PhoneExt
}
